import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const ActividadList = ({ onEdit, onDelete, reloadTrigger }) => {
    const [actividades, setActividades] = useState([]);

    // Función para obtener las actividades desde la API
    const fetchActividades = () => {
        fetch(`${config.apiUrl}/actividades`)
            .then((res) => res.json())
            .then(setActividades)
            .catch(console.error);
    };

    // Efecto para cargar las actividades al inicio y cuando cambie reloadTrigger
    useEffect(() => {
        fetchActividades();
    }, [reloadTrigger]);

    const formatDate = (fecha) => fecha.split("T")[0];


    return (
        <div className="container mt-5">
            <h2 className="mb-4 text-center">Lista de Actividades</h2>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-dark text-center">
                    <thead className="thead-dark">
                    <tr>
                        <th>ID Actividad</th>
                        <th>Materia</th>
                        <th>Nombre de Actividad</th>
                        <th>Tipo de Actividad</th>
                        <th>Fecha</th>
                        <th>Ponderación</th>
                        <th colSpan={2}>Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    {actividades.map((actividad) => (
                        <tr key={actividad.actividad_id}>
                            <td>{actividad.actividad_id}</td>
                            <td>{actividad.nombre_materia}</td>
                            <td>{actividad.nombre_actividad}</td>
                            <td>{actividad.tipo_actividad}</td>
                            <td>{formatDate(actividad.fecha)}</td>
                            <td>{actividad.ponderacion}</td>
                            <td>
                                <button className="btn btn-warning btn-sm me-2"
                                        onClick={() => onEdit({ ...actividad, fecha: actividad.fecha.split("T")[0] })} // Ajuste de formato
                                >
                                    <FontAwesomeIcon icon={faEdit}/>
                                </button>
                            </td>
                            <td>
                                <button className="btn btn-danger btn-sm" onClick={() => onDelete(actividad.actividad_id)}>
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>    );
};

export default ActividadList;